import moment from "moment";

export const newDateWithoutUtc = (date) => {
    return moment.utc(date).format("YYYY-MM-DD");
};

export const newDateWithoutUtcCalendar = (date) => {
    return moment.utc(date).startOf("day").toDate();
};

export const convertToTime = (date) => {
    return date ? moment.utc(date).format('HH:mm') : '';
};

export const convertToAmPm = (date) => {
    return date ? moment.utc(date).format('hh:mm A') : '';
};

export const getTimeAmOrPm = (time24) => {
    const [hourStr, minute] = time24.split(':');

    const hour = parseInt(hourStr, 10);
    return hour >= 12 ? 'PM' : 'AM';
};

export const toAmPm = (time24) => {
    if (time24) {
        const [h, m] = time24.split(':').map(Number);
        const ampm = h >= 12 ? 'PM' : 'AM';
        const hour = h % 12 || 12;
        return `${hour}:${m.toString().padStart(2, '0')} ${ampm}`
    }
}

export const subtractMinutesFromTime = (timeString, minutesToSubtract) => {
    if (timeString && minutesToSubtract) {
        const [hhStr = "0", mmStr = "0"] = timeString.split(":");
        const hh = parseInt(hhStr, 10) || 0;
        const mm = parseInt(mmStr, 10) || 0;
        const total = hh * 60 + mm - minutesToSubtract;
        const mod = ((total % 1440) + 1440) % 1440;
        const newH = Math.floor(mod / 60);
        const newM = mod % 60;
        const pad = n => (n < 10 ? "0" + n : String(n));
        return `${pad(newH)}:${pad(newM)}`;
    }
}

export const setDateOfTime = (date, time) => {
    if (date && time) {
        const dateMoment = moment.utc(date);

        const [hours, minutes] = time.split(':');
        const merged = dateMoment.clone().set({
            hour: Number(hours),
            minute: Number(minutes),
            second: 0,
        });

        return merged.format('YYYY-MM-DDTHH:mm:ss');
    }
    return null;
}

export const convertTo12HourFormat = (time24) => {
    if (!time24 || time24.length < 5) return "";

    const [hourStr, minute] = time24.split(':');
    let hour = parseInt(hourStr, 10);

    if (isNaN(hour)) return "";

    const period = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12;
    const formattedHour = String(hour).padStart(2, '0');
    return `${formattedHour}:${minute} ${period}`;
}